export default __webpack_public_path__ + "static/media/logo-white.5d65b8e9.png";